module.exports = __webpack_public_path__ + "static/media/star_disabled.0b407055.svg";